<template>
  <div
    v-if="isVotingButtonVisible"
    class="awards-top-section__voting-btn-wrapper"
  >
    <a-visibility :hide="true" :on="[$breakpoint.mobile]">
      <a-vote-button class="awards-top-section__voting-btn">
        Vote now
      </a-vote-button>
    </a-visibility>

    <a-visibility :show="true" :on="[$breakpoint.mobile]">
      <a-vote-button
        :border-radius-small="true"
        class="awards-top-section__voting-btn"
      >
        Vote now
      </a-vote-button>
    </a-visibility>
  </div>
</template>

<script>
import AVoteButton from 'sections/_voting/shared/AVoteButton'
import { IS_VOTING_CLOSED } from 'enums/main-route'

export default {
  name: 'AwardsTopSectionVotingButton',
  components: { AVoteButton },
  consts: {
    IS_VOTING_CLOSED
  },
  computed: {
    isVotingButtonVisible() {
      return !IS_VOTING_CLOSED
    }
  }
}
</script>

<style lang="scss" scoped>
.awards-top-section__voting-btn-wrapper {
  display: flex;
  position: relative;
  z-index: 1;

  /deep/ .vote-button__wrapper {
    background-color: $c--black;
  }

  .awards-top-section__voting-btn {
    display: flex;
    margin: 64px auto 0;

    $padding: (
      $above-desktop-xl: 25px 50px,
      $mobile: 13px 50px
    );

    @include setStyleByBreakpoint('padding', $padding);
  }
}
</style>
